import Vue from 'vue'

export default {
  getTeams ({ commit }) {
    return Vue.api.get('engine/teams').then((res) => commit('init', { teams: res.data }))
  },
  inviteTeam ({ dispatch }, data) {
    return Vue.api.post('engine/teams', data).then((res) => {
      dispatch('getUser')
      return res
    })
  },
  inviteCancel ({ dispatch }, invitationId) {
    return Vue.api.delete('engine/teams/invitation/' + invitationId).then((res) => {
      dispatch('getUser')
      dispatch('getTeams')
      return res
    })
  },
  editRole ({ dispatch }, role) {
    return Vue.api.put('engine/teams/' + role.id, role).then((res) => {
      dispatch('getTeams')
      return res
    })
  },
  removeRole ({ dispatch }, roleId) {
    return Vue.api.delete('engine/teams/' + roleId).then((res) => {
      dispatch('getUser')
      dispatch('getTeams')
      return res
    })
  }
}
